import get from 'lodash.get';
import { Component } from 'react';
import PropTypes from 'prop-types';
import { consoleError } from '../../helpers/checkoutDebug';
import styles from './styles/CheckoutErrorPage.scss';
import {
    setPrerenderedCheckoutRootState,
    PRE_RENDER_STATE_ERROR,
} from '../../prerender/prerenderedCheckoutStore';

// components
import { Error500Layout } from 'dibs-buyer-layout/exports/error500';
import LocalSpinner from '../../shared/components/LocalSpinner';
import { disableBeforeUnload } from '../../shared/hooks/useBeforeUnload';

class CheckoutErrorPage extends Component {
    constructor(props) {
        super(props);
        consoleError(props.error);
    }
    componentDidMount() {
        setPrerenderedCheckoutRootState(PRE_RENDER_STATE_ERROR);
    }
    render() {
        if (get(this.props.error, 'source.errors[0].requestInfo.status') === 404) {
            disableBeforeUnload();
            window.location = '/404';
            return <LocalSpinner />;
        }
        return (
            <div className={styles.wrapper}>
                <Error500Layout pageType="checkout/" />
            </div>
        );
    }
}

CheckoutErrorPage.propTypes = {
    error: PropTypes.any,
};

export default CheckoutErrorPage;
